"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CSBody = void 0;
const ui_1 = require("@app/component/ui");
const util_1 = require("@app/util");
const react_1 = __importDefault(require("react"));
const calendar_settings_context_1 = require("../calendar-settings-context");
const cs_view_section_1 = require("./sections/calendar-view/cs-view-section");
const cs_delete_shifts_section_1 = require("./sections/cs-delete-shifts-section");
const cs_dev_section_1 = require("./sections/cs-dev-section");
const cs_legend_section_1 = require("./sections/cs-legend-section");
const cs_warning_section_1 = require("./sections/cs-warning-section");
const cs_shift_section_1 = require("./sections/shift-settings/cs-shift-section");
const cs_timeoff_section_1 = require("./sections/timeoff-settings/cs-timeoff-section");
const sections = new Map([
    ['view', cs_view_section_1.CSViewSection],
    ['shift', cs_shift_section_1.CSShiftSection],
    ['timeoff', cs_timeoff_section_1.CSTimeOffSection],
    ['warning', cs_warning_section_1.CSWarningSection],
    ['dev', cs_dev_section_1.CSDevSection],
    ['legend', cs_legend_section_1.CSLegendSection],
    ['delete-shifts', cs_delete_shifts_section_1.CSDeleteShiftsSection],
]);
const CSBody = () => {
    const { selectedTab } = (0, calendar_settings_context_1.useCalendarSettingsContext)();
    const Section = sections.get(selectedTab);
    if ((0, util_1.isDefined)(Section)) {
        return (react_1.default.createElement("div", { style: { padding: '0.625rem' } },
            react_1.default.createElement(Section, null)));
    }
    return (react_1.default.createElement("div", { style: { padding: '0.625rem' } },
        react_1.default.createElement(ui_1.Alert, { type: 'ERROR', text: `Section "${selectedTab}" not found.` })));
};
exports.CSBody = CSBody;
